let kendoLoading: Promise<any>;

export function ensureKendo(): Promise<any> {
	if (!kendoLoading) {
		// @ts-ignore
		kendoLoading = import(/* webpackChunkName: "kendo" */ '@synisys/idm-ui-shell/app/lib/kendo/kendo-custom-bundle.js')
			.then(() => window['kendo']);
		// allow a retry (e.g. after a network error) instead of caching the failure
		kendoLoading.catch(() => kendoLoading = undefined);
	}
	return kendoLoading;
}

window['ensureKendo'] = ensureKendo;
